import { Coordinates } from '../models';
import { LengthUnits } from '../enums';
import { convertDistance } from './convert-distance';
import { haversine } from './haversine';

export function calculateDistance(point1: Coordinates, point2: Coordinates): number {
  return convertDistance(haversine(point1, point2), LengthUnits.meter, LengthUnits.feet);
}
